/*@ngInject*/
const ClassCodeGroupingsRepository = function (baseCachedSharedPromiseRepository) {

    var sharedPromiseCache = {};

    angular.extend(this, baseCachedSharedPromiseRepository);

    this.getCacheName = function () {
        return 'classCodeGroupingsRepository';
    };

    this.getCacheCapacity = function () {
        return 25;
    };

    this.getSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.getClassCodeGroupings = function (classCodeType, effectiveDate) {
        var url = '/rest/ClassCode/Groupings',
            config = {
                params: {
                    classCodeType: classCodeType,
                    effectiveDate: moment(effectiveDate).format('YYYY-MM-DD')
                }
            },
            cacheKey = classCodeType + effectiveDate;

        return this.get(cacheKey, url, config);
    };
};

angular.module('umFormViewer')
    .service('classCodeGroupingsRepository', ClassCodeGroupingsRepository);
